import useSWR from "swr";
import useSWRImmutable from "swr/immutable";
import useSWRMutation from "swr/mutation";

import { RequestConfig } from "../../lib/api/ApiTypes";
import Endpoint from "../../lib/api/Endpoint";

const fetch = async (
	key: any,
	requestConfig: {
		arg: { api: Endpoint; config: RequestConfig<any, any, any, any> };
	},
	opts?: any,
) => {
	const { api, config } = requestConfig.arg;
	const res = await api.submit(config);

	return res.data;
};

export const useMutation = (key: any, api: Endpoint<any, any, any, any>) => {
	const { trigger, isMutating, data, error } = useSWRMutation(
		key || api.id,
		fetch,
	);

	const handleTrigger = async (requestConfig: Partial<RequestConfig>) => {
		return await trigger({ api: api, config: requestConfig });
	};

	return { trigger: handleTrigger, isMutating, data, error };
};

export const useDefault = (
	key: any,
	api: () => Promise<any>,
	defaultValue?: any,
	opts?: any,
) => {
	const swrKey = key;
	const { data, error, mutate, isLoading, isValidating } = useSWR(
		swrKey,
		api,
		opts,
	);

	return { data: data || defaultValue, error, mutate, isLoading, isValidating };
};

export const useImmutable = (
	key: any,
	api: () => Promise<any>,
	defaultValue?: any,
	opts?: any,
) => {
	const swrKey = key;
	const { data, error, mutate, isLoading, isValidating } = useSWRImmutable(
		swrKey,
		api,
		opts,
	);

	return { data: data || defaultValue, error, mutate, isLoading, isValidating };
};
